import { reducer as system } from "features/System";
import { reducer as groups } from "features/Groups";
import { reducer as workspace } from "features/Workspace";

export default {
  system,
  groups,
  workspace,
};
